import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const EditAdminCatModal = ({ isOpen, onClose, editFormData, setEditFormData, fetchData }) => {
  const [submitting, setSubmitting] = useState(false);
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const slNo = editFormData?.slNo;
    const catName = (editFormData?.catName || "").trim();

    if (!slNo) {
      Swal.fire({ icon: "error", title: "Missing id", text: "Record id (Sl No) is missing." });
      return;
    }
    if (!catName) {
      Swal.fire({ icon: "warning", title: "Missing name", text: "Category name is required." });
      return;
    }

    setSubmitting(true);
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const url = `${API_BASE}/admin_CatEdit/${encodeURIComponent(slNo)}`;

      const response = await axios.put(
        url,
        { slNo, catName },
        { timeout: 15000 } // <- prevents hanging forever
      );

      Swal.close(); // <- ALWAYS close the loading dialog
      if (response.data?.success) {
        await Swal.fire({ icon: "success", title: "Updated!", text: "updated successfully." });
        onClose?.();
        fetchData?.();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data?.message || "Update failed.",
        });
      }
    } catch (error) {
      Swal.close(); // <- close on error too
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Update failed. Please try again.";
      await Swal.fire({ icon: "error", title: "Error", text: msg });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: 10, right: 10 }}>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>

        <h3>Edit Admin Category</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Category Name :</label>
              <input
                type="text"
                name="catName"
                value={editFormData.catName ?? ""}
                onChange={handleEditChange}
                disabled={submitting}
                required
              />
            </div>
          </div>

          <div className="btn-cls">
            <button type="submit" className="submit-btn" disabled={submitting}>
              {submitting ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAdminCatModal;
